module.exports = __webpack_public_path__ + "img/icon-document.73b58490.svg";